<template>
	<div>
		<el-breadcrumb separator="/">
			<el-breadcrumb-item>账号信息</el-breadcrumb-item>
			<el-breadcrumb-item>修改密码</el-breadcrumb-item>
		</el-breadcrumb>

		<div style="width:500px; margin:50px auto 0;">
			<el-form ref="form" label-position="right" :rules="rules" label-width="120px" :model="pwdform">
				<el-form-item label="用户名">
					<span v-text="userInfo.username"></span>
				</el-form-item>
				<el-form-item label="当前密码" prop="oldPassword">
					<el-input type="password" v-model="pwdform.oldPassword"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="password">
					<el-input type="password" v-model="pwdform.password"></el-input>
				</el-form-item>
				<el-form-item label="新密码确认" prop="confirmPassword">
					<el-input type="password" v-model="pwdform.confirmPassword"></el-input>
				</el-form-item>
				<el-form-item label="" style="padding-top:20px;">
					<el-button type="primary" @click="save">保存</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapGetters } from 'vuex'

	export default {
		data() {
			var validatePass = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请输入密码'))
				} else {
					callback()
				}
			}
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'))
				} else if (value !== this.pwdform.password) {
					callback(new Error('两次输入密码不一致!'))
				} else {
					callback()
				}
			}

			return {
				labelPosition: 'right',
				pwdform: {
					confirmPassword: '',
					oldPassword: '',
					password: '',
					username: '',
				},
				rules: {
					oldPassword: [{ required: true, message: '请输入密码', trigger: 'blur' }],
					password: [
						{
							required: true,
							validator: validatePass,
							trigger: 'blur',
						},
					],
					confirmPassword: [
						{
							required: true,
							validator: validatePass2,
							trigger: 'blur',
						},
					],
				},
			}
		},
		computed: {
			...mapGetters(['userInfo']),
		},
		methods: {
			...mapActions(['ChangePassowrd']),
			/**
			 * 修改密码。
			 */
			save() {
				//lingyun123@

				this.pwdform.username = this.userInfo.username
				this.$refs['form'].validate(valid => {
					if (valid) {
						this.ChangePassowrd(this.pwdform).then(
							res => {
								if (res.success) {
									this.$message.success('密码修改成功，请在下次登录使用新密码。')
								} else {
									this.$message.error(`(${res.code}),${res.message}`)
								}
							},
							error => {
								this.$message.error(error.message)
							}
						)
					} else {
						console.log('error submit!!')
						return false
					}
				})
			},
		},
	}
</script>

<style scoped></style>
